"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSCWriter = void 0;
var TokenFormat_1 = require("./TokenFormat");
var TokenValidator_1 = __importStar(require("./TokenValidator"));
var KeyPair_1 = require("./KeyPair");
var KeyRing_1 = __importDefault(require("./KeyRing"));
var Timestamp_1 = require("./Timestamp");
var UUID_1 = __importDefault(require("./UUID"));
var RSA_1 = __importDefault(require("./RSA"));
var Authorities_1 = __importDefault(require("./Authorities"));
var JSONChainedToken_1 = __importDefault(require("./JSONChainedToken"));
var Telemetry_1 = require("./Telemetry");
var wrapLine_1 = require("./wrapLine");
var debug_1 = __importDefault(require("./debug"));
var uuidToB64_1 = require("./uuidToB64");
var debug = debug_1.default.extend('jsc');
/**
 * JSON Signed Certificate Contain a signed certificate, generated from a JCR,
 * and verified by the Authority using the provided Authentication
 * certificate size is around 500 bytes
 */
var JSCWriter = /** @class */ (function () {
    /**
     *
     * @param prv Private key to use to sign the certificates
     * @param issuer value of issuer to put in the certificate, must match
     * domain where public key can be fetched from
     * @param max_lifespan the maximum lifespan aloted for those certificate.
     * default to 90 days
     */
    function JSCWriter(prv, issuer, max_lifespan) {
        if (max_lifespan === void 0) { max_lifespan = 90 * 24 * 60 * 60; }
        this.prv = prv;
        this.iss = issuer;
        this.max_lifespan = max_lifespan;
    }
    /**
     * This method only add signature on the request, and does not perform any
     * other validation. Therefore, the calling code MUST confirm that the
     * request is valid and was submited by a party that was authorized to do
     * so. Said information should be present in the jcr body, notably in the
     * .sub field, and optionally in the .etc.something fields
     * @param jcr JSON Certificate Request to sign
     */
    JSCWriter.prototype.sign = function (jcr_1, identity_1) {
        return __awaiter(this, arguments, void 0, function (jcr, identity, chain_cert, additionalEtc, lightWeight, compress) {
            var lwo, headers, certIdentity, now, exp, empty, _k, new_body, _a, _b, _c, empty, _k, _i, _d, ecid, token_parts, unsigned_token, signature, expectedPub;
            var _e;
            var _f, _g, _h;
            if (chain_cert === void 0) { chain_cert = null; }
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        // validate chain cert is usable with this key
                        if (chain_cert) {
                            if (!('keyid' in chain_cert.pub)) {
                                debug('skipping keyid validation, lightweight certificate used');
                            }
                            else if (chain_cert.pub.keyid !== this.prv.keyid) {
                                throw new Error("Invalid certificate, keyid does not match our private key id");
                            }
                        }
                        lwo = {
                            body_kid: (_f = (typeof lightWeight === 'object' ? lightWeight === null || lightWeight === void 0 ? void 0 : lightWeight.body_kid : lightWeight)) !== null && _f !== void 0 ? _f : false,
                            header_kid: (_g = (typeof lightWeight === 'object' ? lightWeight === null || lightWeight === void 0 ? void 0 : lightWeight.header_kid : lightWeight)) !== null && _g !== void 0 ? _g : false,
                            header_alg: (_h = (typeof lightWeight === 'object' ? lightWeight === null || lightWeight === void 0 ? void 0 : lightWeight.header_alg : lightWeight)) !== null && _h !== void 0 ? _h : false,
                        };
                        headers = {
                            typ: 'JSC',
                        };
                        if (!lwo.header_kid) {
                            headers.kid = this.prv.keyid;
                            if (!lwo.header_alg) {
                                headers.alg = 'RS256';
                            }
                            else {
                                headers.typ += ':L';
                            }
                        }
                        else {
                            headers.typ += ':L';
                        }
                        certIdentity = (function (_a) {
                            var sub = _a.sub, others = __rest(_a, ["sub"]);
                            return (__assign({}, others));
                        })(identity instanceof JSC || identity instanceof JSONChainedToken_1.default ? identity.identity : identity);
                        now = (0, Timestamp_1.now)();
                        exp = now + this.max_lifespan;
                        if ('contact' in certIdentity &&
                            typeof certIdentity.contact === 'object' &&
                            certIdentity.contact &&
                            certIdentity.contact.type === 'domain') {
                            exp = now + 365 * 24 * 60 * 60;
                        }
                        if ('misc' in certIdentity && typeof certIdentity.misc === 'object' && certIdentity.misc) {
                            empty = true;
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            for (_k in certIdentity.misc) {
                                empty = false;
                                break;
                            }
                            if (empty) {
                                delete certIdentity.misc;
                            }
                        }
                        _a = [__assign({}, jcr.body)];
                        _e = { etc: __assign(__assign({}, jcr.body.etc), (additionalEtc !== null && additionalEtc !== void 0 ? additionalEtc : {})), iss: this.iss, iat: now, exp: jcr.body.exp && jcr.body.exp < exp ? jcr.body.exp : exp, idt: certIdentity };
                        _b = 'cert-';
                        _c = uuidToB64_1.uuidToB64;
                        return [4 /*yield*/, (0, UUID_1.default)()];
                    case 1:
                        new_body = __assign.apply(void 0, _a.concat([(_e.cid = _b + _c.apply(void 0, [_j.sent()]), _e)]));
                        if ('etc' in new_body && typeof new_body.etc === 'object' && new_body.etc) {
                            empty = true;
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            for (_k in new_body.etc) {
                                empty = false;
                                break;
                            }
                            if (empty) {
                                delete new_body.etc;
                            }
                        }
                        if (lwo.body_kid) {
                            if ('kid' in new_body) {
                                delete new_body['kid'];
                            }
                        }
                        // we always remove the lightweight requirement from the body
                        if ('lightweight' in new_body) {
                            delete new_body['lightweight'];
                        }
                        if ('compressed' in new_body) {
                            delete new_body['compressed'];
                        }
                        // add extend certificate ids, if applicable
                        // TODO do not include certificate id that aren't issued by the root
                        // authority
                        // TODO make sure the expiration date of the new certificate is not
                        // beyond the one of any of the included certificate
                        if (identity instanceof JSC) {
                            if (!new_body.ecs) {
                                new_body.ecs = [];
                            }
                            if (!new_body.ecs.includes(identity.body.cid)) {
                                new_body.ecs.push(identity.body.cid);
                            }
                            if (identity.body.ecs && identity.body.ecs.length > 0) {
                                for (_i = 0, _d = identity.body.ecs; _i < _d.length; _i++) {
                                    ecid = _d[_i];
                                    if (!new_body.ecs.includes(ecid)) {
                                        new_body.ecs.push(ecid);
                                    }
                                }
                            }
                        }
                        if (compress === true) {
                            if (headers.typ === 'JSC:L') {
                                headers.typ += 'C';
                            }
                            else {
                                headers.cmp = 'zlib';
                            }
                        }
                        token_parts = [(0, TokenFormat_1.encode)(headers), (0, TokenFormat_1.encode)(new_body, compress), (0, KeyPair_1.stripPEMExtra)(jcr.pub.data)];
                        if (chain_cert) {
                            token_parts.push(chain_cert.raw);
                        }
                        unsigned_token = token_parts.join('.');
                        return [4 /*yield*/, RSA_1.default.sign(this.prv, unsigned_token)];
                    case 2:
                        signature = _j.sent();
                        if (!chain_cert) return [3 /*break*/, 4];
                        expectedPub = __assign({ keyid: this.prv.keyid }, chain_cert.pub);
                        return [4 /*yield*/, RSA_1.default.verify(expectedPub, unsigned_token, signature)];
                    case 3:
                        if (!(_j.sent())) {
                            throw new Error('Failed to validate freshly signed token with provided chain cert');
                        }
                        _j.label = 4;
                    case 4: return [2 /*return*/, unsigned_token + '.' + signature];
                }
            });
        });
    };
    return JSCWriter;
}());
exports.JSCWriter = JSCWriter;
var JSC = /** @class */ (function () {
    function JSC(raw) {
        this.validator = new TokenValidator_1.default(raw, function (n) { return n % 4 === 0; }, [
            'JSC',
            'JSC:L',
            'JSC:LC',
        ]);
        if (this.validator.header.kid === null) {
            debug('Lightweight certificate, missing kid');
        }
        this.header = this.validator.header;
        var compressed = this.header.cmp === 'zlib' || this.header.typ === 'JSC:LC';
        this.body = this.validator.next_is_body(true, compressed); // segment #1
        this.pub = {
            data: (0, KeyPair_1.addPEMExtra)(this.validator.next(), 'PUBLIC KEY'), // segment #2
        };
        if ('kid' in this.body) {
            this.pub = __assign(__assign({}, this.pub), { keyid: this.body.kid });
        }
        if (this.validator.remaining > 1) {
            this.parent_cert = new JSC(this.validator.next_few(-1));
        }
        else {
            this.parent_cert = null;
        }
    }
    Object.defineProperty(JSC.prototype, "generation", {
        /**
         * return how many certificate have been used to sign this one. A first
         * level certificate will have a generation of 1
         */
        get: function () {
            return 1 + (this.parent_cert ? this.parent_cert.generation : 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JSC.prototype, "ancestor_certificate", {
        /**
         * return the generation 1 certificate of this chain, or undefined on a
         * 1 generation certificate
         */
        get: function () {
            if (this.parent_cert) {
                return this.parent_cert.ancestor_certificate || this.parent_cert;
            }
            return;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * return the certificate with the requested generation, or undefined if
     * none that old exists
     */
    JSC.prototype.getCertificateGeneration = function (generation) {
        if (generation === 1) {
            return this;
        }
        else if (this.parent_cert) {
            return this.parent_cert.getCertificateGeneration(generation - 1);
        }
        return;
    };
    /**
     * Return an array will all values for a specific attribute, that is nested
     * under the .etc field of any certificate of the chain.
     *
     * last values of the array are from the deepest certificate (oldest
     * generation)
     *
     * @param key attribute to get from the .etc field of each certificate
     */
    JSC.prototype.getFromEtcs = function (key) {
        var results = this.parent_cert ? this.parent_cert.getFromEtcs(key) : [];
        if (this.body.etc && key in this.body.etc) {
            results.unshift(this.body.etc[key]);
        }
        return results;
    };
    Object.defineProperty(JSC.prototype, "certificate_id", {
        get: function () {
            return this.body.cid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JSC.prototype, "extended_certificate_ids", {
        /**
         * Returns all the certificate id that must still be valid (not revoked)
         */
        get: function () {
            return __spreadArray([this.certificate_id], (this.body.ecs ? this.body.ecs : []), true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JSC.prototype, "certificate_chain", {
        get: function () {
            var result = [this];
            if (this.parent_cert) {
                result.push.apply(result, this.parent_cert.certificate_chain);
            }
            return result;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JSC.prototype, "identity", {
        get: function () {
            return __assign(__assign({}, this.body.idt), { sub: this.body.sub });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JSC.prototype, "issuer", {
        get: function () {
            return this.body.iss;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JSC.prototype, "sub", {
        get: function () {
            return this.body.sub;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JSC.prototype, "raw", {
        get: function () {
            return this.validator.raw();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JSC.prototype, "encoded", {
        get: function () {
            return this.validator.raw();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JSC.prototype, "expireTimestamp", {
        /**
         * Returns the earliest expiration between this certificate and it's parent,
         * if applicable
         */
        get: function () {
            var exp = this.body.exp;
            if (this.parent_cert) {
                var parent_exp = this.parent_cert.expireTimestamp;
                if (parent_exp < exp) {
                    return parent_exp;
                }
            }
            return exp;
        },
        enumerable: false,
        configurable: true
    });
    JSC.prototype.toString = function () {
        return this.raw;
    };
    JSC.prototype.formatHumanReadable = function () {
        return JSC.format(this);
    };
    JSC.prototype.isExpired = function (now) {
        if (now === void 0) { now = undefined; }
        if (now === false) {
            return false;
        }
        if (now === undefined || now === true) {
            now = (0, Timestamp_1.now)();
        }
        return this.expireTimestamp < now;
    };
    JSC.prototype.willExpireIn = function (exp_in) {
        var now = (0, Timestamp_1.now)() + (exp_in ? exp_in : 0);
        return this.expireTimestamp < now;
    };
    /**
     * Will tell if the certificate's ttl is technically long enough to be able
     * to provide the desired exp_in
     * @param exp_in Amount of second that is desired to be expiring in
     */
    JSC.prototype.shouldBeRenewed = function (exp_in) {
        if (this.willExpireIn(exp_in)) {
            if (!exp_in) {
                // certificate is expired, and no specific exp_in was provided, we
                // therefore just renew the cert
                return true;
            }
            else if (this.certTtl > exp_in) {
                // test if the ttl is long enough, so that a fresh certificate would be
                // able to be generated for that long
                // otherwise, there's no chance we can give that exp_in delays
                return true;
            }
            else {
                // Nothing for the moment, but the certificate we have will not
                // be able to provide the proper ttl
            }
        }
        // no need to renew!
        return false;
    };
    Object.defineProperty(JSC.prototype, "certTtl", {
        get: function () {
            return this.body.exp - this.body.iat;
        },
        enumerable: false,
        configurable: true
    });
    JSC.prototype.verify = function (authorities, options) {
        return __awaiter(this, void 0, void 0, function () {
            var telemetry, results;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        telemetry = (_a = options === null || options === void 0 ? void 0 : options.telemetry) !== null && _a !== void 0 ? _a : new Telemetry_1.Telemetry('JSC verify');
                        return [4 /*yield*/, Promise.all([
                                telemetry.fork('integrity', function (t) { return _this.verify_integrity(authorities, __assign(__assign({}, options), { telemetry: t })); }),
                                telemetry.fork('revoke_status', function (t) {
                                    return _this.verify_revoke_status(authorities, __assign(__assign({}, options), { telemetry: t }));
                                }),
                            ])];
                    case 1:
                        results = _b.sent();
                        return [2 /*return*/, results.reduce(function (_a, _b) {
                                var prev_ok = _a[0], prev_errors = _a[1];
                                var curr_ok = _b[0], curr_errors = _b[1];
                                return [
                                    prev_ok && curr_ok,
                                    prev_errors.concat(curr_errors),
                                ];
                            })];
                }
            });
        });
    };
    JSC.prototype.verify_revoke_status = function (authorities, options) {
        return __awaiter(this, void 0, void 0, function () {
            var telemetry, revoked_cert_ids, errors;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        telemetry = (_a = options === null || options === void 0 ? void 0 : options.telemetry) !== null && _a !== void 0 ? _a : new Telemetry_1.Telemetry('JSC verify revoke status');
                        return [4 /*yield*/, telemetry.seq('areAnyCertRevoked', function (t) {
                                return authorities.areAnyCertificateRevoked(_this.certificate_chain, options === null || options === void 0 ? void 0 : options.revokeListTTL, t);
                            })];
                    case 1:
                        revoked_cert_ids = _b.sent();
                        errors = [];
                        if (revoked_cert_ids.length > 0) {
                            revoked_cert_ids.forEach(function (cert_id) {
                                if (_this.extended_certificate_ids.includes(cert_id)) {
                                    if (!errors.includes(TokenValidator_1.ValidationError.AgentCertificateRevoked)) {
                                        errors.push(TokenValidator_1.ValidationError.AgentCertificateRevoked);
                                    }
                                }
                                else if (_this.parent_cert && _this.parent_cert.extended_certificate_ids.includes(cert_id)) {
                                    if (!errors.includes(TokenValidator_1.ValidationError.ServiceCertificateRevoked)) {
                                        errors.push(TokenValidator_1.ValidationError.ServiceCertificateRevoked);
                                    }
                                }
                                else {
                                    if (!errors.includes(TokenValidator_1.ValidationError.OtherCertificateRevoked)) {
                                        errors.push(TokenValidator_1.ValidationError.OtherCertificateRevoked);
                                    }
                                }
                            });
                        }
                        return [2 /*return*/, [revoked_cert_ids.length === 0 ? true : false, errors]];
                }
            });
        });
    };
    JSC.prototype.verify_integrity = function (authorities, options) {
        return __awaiter(this, void 0, void 0, function () {
            var telemetry, parent_cert_1, _a, cert_ok, errors;
            var _this = this;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        telemetry = (_b = options === null || options === void 0 ? void 0 : options.telemetry) !== null && _b !== void 0 ? _b : new Telemetry_1.Telemetry('JSC verify integrity');
                        if (!this.parent_cert) return [3 /*break*/, 3];
                        parent_cert_1 = this.parent_cert;
                        return [4 /*yield*/, telemetry.seq('validator parent cert', function (t) {
                                return _this.validator.verify(parent_cert_1.pub, __assign(__assign({}, options), { telemetry: t }));
                            })];
                    case 1:
                        _a = _c.sent(), cert_ok = _a[0], errors = _a[1];
                        // fail early
                        if (!cert_ok) {
                            return [2 /*return*/, [cert_ok, errors]];
                        }
                        return [4 /*yield*/, telemetry.seq('parent cert integrity', function (t) {
                                return parent_cert_1.verify_integrity(authorities, __assign(__assign({}, options), { telemetry: t }));
                            })];
                    case 2: 
                    // validate parent cert after
                    return [2 /*return*/, _c.sent()];
                    case 3:
                        // no parent cert, just verify current cert
                        if (!this.header.kid) {
                            throw new Error('Root certificate must include a header.kid');
                        }
                        return [4 /*yield*/, telemetry.seq('validator', function (t) { return __awaiter(_this, void 0, void 0, function () {
                                var pubKey;
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, t.seq('getPublicKey', function (st) {
                                                return getPublicKey(authorities, _this.body.iss, _this.header.kid, st);
                                            })];
                                        case 1:
                                            pubKey = _a.sent();
                                            return [2 /*return*/, t.seq('verify', function (st) {
                                                    return _this.validator.verify(pubKey, __assign(__assign({}, options), { telemetry: st }));
                                                })];
                                    }
                                });
                            }); })];
                    case 4: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    JSC.prototype.verify_signature = function (pub_or_ring, telemetry) {
        return __awaiter(this, void 0, void 0, function () {
            var parent_cert_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!telemetry) {
                            telemetry = new Telemetry_1.Telemetry('JSC verify signature');
                        }
                        if (!this.parent_cert) return [3 /*break*/, 3];
                        parent_cert_2 = this.parent_cert;
                        return [4 /*yield*/, telemetry.seq('verify signature', function (t) { return _this.validator.signature_matches(parent_cert_2.pub, t); })];
                    case 1:
                        if (!(_a.sent())) {
                            // fail early
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, telemetry.seq('verify parent signature', function (t) { return parent_cert_2.verify_signature(pub_or_ring, t); })];
                    case 2: 
                    // if the current signature is good, confirm the parent signature is good
                    return [2 /*return*/, _a.sent()];
                    case 3:
                        if (!this.header.kid) {
                            throw new Error('Root certificate must include a header.kid');
                        }
                        return [4 /*yield*/, telemetry.seq('verify signature', function (t) { return __awaiter(_this, void 0, void 0, function () {
                                var pubKey;
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, t.seq('getPublicKey', function (st) {
                                                return getPublicKey(pub_or_ring, _this.body.iss, _this.header.kid, st);
                                            })];
                                        case 1:
                                            pubKey = _a.sent();
                                            return [4 /*yield*/, t.seq('signature_matches', function (st) { return _this.validator.signature_matches(pubKey, st); })];
                                        case 2: return [2 /*return*/, _a.sent()];
                                    }
                                });
                            }); })];
                    case 4: 
                    // no parent cert, just verify current signature
                    return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSC.format = function (cert, idx, idt) {
        if (idx === void 0) { idx = 1; }
        if (idt === void 0) { idt = '\n'; }
        return __spreadArray(__spreadArray([
            '\n',
            "# Cert [".concat(idx, "] header (").concat(cert.validator.at(0).length, " bytes)"),
            '# ' + cert.validator.at(0),
            JSON.stringify(cert.header),
            '\n',
            "# Cert [".concat(idx, "] body (").concat(cert.validator.at(1).length, " bytes)"),
            '# ' + (0, wrapLine_1.wrapLine)(cert.validator.at(1)).join('\n# ')
        ], JSON.stringify(cert.body, null, 4).split('\n'), true), [
            '\n',
            "# Cert [".concat(idx, "] public key (PEM w/o header & footer)  (").concat(cert.validator.at(2).length, " bytes)"),
            cert.validator.at(2),
            cert.parent_cert ? JSC.format(cert.parent_cert, idx + 1, "".concat(idt, "\t")) : null,
            '\n',
            "# Cert [".concat(idx, "] signature  (").concat(cert.validator.signature.length, " bytes)"),
            cert.validator.signature,
        ], false).filter(function (e) { return e !== null; })
            .join(idt);
    };
    return JSC;
}());
exports.default = JSC;
function getPublicKey(pub_or_ring_or_authorities, issuer, keyid, telemetry) {
    return __awaiter(this, void 0, void 0, function () {
        var pub, attempt;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!telemetry) {
                        telemetry = new Telemetry_1.Telemetry('getPublicKey');
                    }
                    pub = null;
                    attempt = 'none';
                    if (!(pub_or_ring_or_authorities instanceof Authorities_1.default)) return [3 /*break*/, 2];
                    attempt = 'authorities';
                    return [4 /*yield*/, telemetry.seq('authorities obtain', function (t) {
                            return pub_or_ring_or_authorities.keyring.obtain(issuer, keyid, t);
                        })];
                case 1:
                    pub = _a.sent();
                    return [3 /*break*/, 5];
                case 2:
                    if (!(pub_or_ring_or_authorities instanceof KeyRing_1.default)) return [3 /*break*/, 4];
                    attempt = 'keyring';
                    return [4 /*yield*/, telemetry.seq('keyring obtain', function (t) { return pub_or_ring_or_authorities.obtain(issuer, keyid, t); })];
                case 3:
                    pub = _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    attempt = 'pubkey';
                    pub = pub_or_ring_or_authorities;
                    _a.label = 5;
                case 5:
                    if (pub instanceof Array) {
                        pub = pub.find(function (p) { return p.keyid === keyid; });
                    }
                    if (!pub) {
                        throw new Error("Failed to obtain issuer's (".concat(issuer, ") public key, attempted via: ").concat(attempt));
                    }
                    return [2 /*return*/, pub];
            }
        });
    });
}
